// Shared constants for the global "E-Signature Required" Application Setting.
// Read via useAppSetting(ESIGN_REQUIRED_SETTING, true) — defaults to required (true) so a
// missing/unsaved setting never silently disables signing. When a caller turns it off, every
// e-sign modal in the app (ESignAuth, DualESignatureAuth, SignedActionModal, ConfirmWithReason,
// and the ESignatureModal family) auto-completes instead of prompting for credentials, using
// ESIGN_BYPASS_USER / ESIGN_BYPASS_REASON below so the bypass is always clearly marked, never
// mistaken for a real signed credential.
export const ESIGN_REQUIRED_SETTING = 'E-Signature Required';
export const ESIGN_BYPASS_USER = 'SYSTEM';
export const ESIGN_BYPASS_REASON = 'E-signature not required (disabled in Application Settings)';
